import React from 'react';
import { t } from '../../services/i18nService';

class LockDownRequirementsFailed extends React.Component {
    render() {
        return (
            <h1>{t('session.lockDownRequirementsFailed')}</h1>
        );
    }
}

export default LockDownRequirementsFailed;
